import { GenericError, errorMessage } from '../../../../utils/errors';
import { fetchJSON } from '../../../../utils/fetch';

import { Feature, VehicleCatalogResponse } from '../../../../services/victor/config-start-response';
import { HealEndpointVehicleConfiguration } from '../../../../services/victor/config-step-response';
import { rootStore } from '../../../root-store';
import { featureAppStoreActions } from '../../feature-app-store';

// Why is this here? Because it is only used here.

interface HealConfigurationInput {
	carConfiguration: HealEndpointVehicleConfiguration;
	cacheKey?: string;
}

interface SolutionCandidate {
	addedFeatures: Feature[];
}

interface ConfigStepResponse {
	validationData: {
		conflicted: boolean;
		solutionCandidates?: SolutionCandidate[];
	};
	solvedVehicleConfiguration?: VehicleCatalogResponse['vehicleConfiguration'];
	vehicleConfiguration: VehicleCatalogResponse['vehicleConfiguration'];
}

export async function configStep({
	carConfiguration,
	cacheKey
}: HealConfigurationInput): Promise<ConfigStepResponse | undefined> {
	const victorServiceConfig = featureAppStoreActions.getServiceConfig('oneapi-victor');
	if (!victorServiceConfig) {
		errorMessage('Unable to get victorServiceConfig please check you are not in a no-victor market');
		return;
	}

	const [_, currentModelValue] = rootStore.currentModel.get();
	if (!currentModelValue) {
		errorMessage('Unable to get currentModel from store, please contact dev team');
		return;
	}

	const { tenant } = currentModelValue.vehicleConfiguration || { tenant: '' };

	const { urlOrigin, credentials } = victorServiceConfig;

	const initRequest: RequestInit = {
		body: JSON.stringify(carConfiguration),
		headers: [['Content-Type', 'application/json']],
		method: 'POST'
	};

	const urlParams = new URLSearchParams({
		tenant,
		fetchPrices: 'true',
		fetchInvisible: 'true',
		fetchWltp: 'true',
		fetchFeatureCategoriesAndFamilies: 'true',
		fetchMediaForConfiguration: 'true',
		fetchMediaForFeatures: 'true',
		addErrorMps: 'true'
	});

	if (cacheKey) {
		urlParams.set('cacheKey', cacheKey);
	}

	const vcsoPath = `vcso/configStep?${urlParams.toString()}`;

	const url = `${urlOrigin}/${vcsoPath}`;

	const vehicleConfiguration = await fetchJSON<ConfigStepResponse>({ url, credentials }, initRequest);

	if (!vehicleConfiguration) {
		throw new GenericError('Missing configuration from configStep endpoint. Contact Dev team');
	}

	return vehicleConfiguration;
}
